export const REGULAR_BOTTLING = 750
export const IS_STRIPE_ENABLED = true

export const listUserGroups = [
  { id: "USER", name: "Individual" },
  { id: "WINEMAKER", name: "Winemaker" },
  { id: "HORECA", name: "Professional" },
  { id: "WHOLESALER", name: "Wholesaler" },
  { id: "ADMIN", name: "Admin" }
]
export const listTerms = [
  { id: 1, name: "Due upon receipt", nbDays: 0 },
  { id: 6, name: "10 days", nbDays: 10 },
  { id: 2, name: "30 days", nbDays: 30 },
  { id: 3, name: "60 days", nbDays: 60 },
  { id: 4, name: "90 days", nbDays: 90 },
  { id: 5, name: "120 days", nbDays: 120 }
]
//Temporary don't allow customers to choose long payment terms
export const listTermsCustomer = [
  { id: 1, name: "Due upon receipt" },
  { id: 6, name: "10 days" },
  { id: 2, name: "30 days" }
]

export const COUNTRIES = {
  FRANCE: {
    id: 73,
    iso2: "FR",
    isoCode: "FRA"
  },
  USA: {
    id: 226,
    iso2: "US",
    isoCode: "USA"
  },
  BAHAMAS: {
    id: 16,
    iso2: "BS",
    isoCode: "BHS"
  },
  BRAZIL: {
    id: 30,
    iso2: "BR",
    isoCode: "BRA"
  }
}
export const REGIONS = {
  FRANCE: {
    BORDEAUX: {
      id: 4,
      text: "Bordeaux"
    }
  }
}

export const listCurrencies = [
  { id: "AUD", name: "Australian dollar (AU$)", symbol: "AU$", implanted_market: false },
  { id: "GBP", name: "British pound (£)", symbol: "£", implanted_market: true },
  { id: "BGN", name: "Bulgarian lev (BGN)", symbol: "BGN", implanted_market: true },
  { id: "CAD", name: "Canadian dollar (CAD)", symbol: "CAD", implanted_market: false },
  { id: "CNY", name: "Chinese yuan (¥)", symbol: "¥", implanted_market: false },
  { id: "CZK", name: "Czech koruna (CZK)", symbol: "CZK", implanted_market: true },
  { id: "DKK", name: "Danish krone (DKK)", symbol: "DKK", implanted_market: true },
  { id: "EUR", name: "Euro (€)", symbol: "€", implanted_market: true },
  { id: "HKD", name: "Hong Kong dollar (HK$)", symbol: "HK$", implanted_market: true },
  { id: "HUF", name: "Hungarian forint (HUF)", symbol: "HUF", implanted_market: true },
  { id: "INR", name: "Indian rupee (₹)", symbol: "₹", implanted_market: false },
  { id: "IDR", name: "Indonesian rupiah (IDR)", symbol: "IDR", implanted_market: false },
  { id: "ILS", name: "Israeli shekel (ILS)", symbol: "ILS", implanted_market: false },
  { id: "MYR", name: "Malaysian ringgit (RM)", symbol: "RM", implanted_market: false },
  { id: "MXN", name: "Mexican peso (MXN)", symbol: "MXN", implanted_market: false },
  { id: "NZD", name: "New Zealand dollar (NZD)", symbol: "NZD", implanted_market: false },
  { id: "NOK", name: "Norwegian krone (NOK)", symbol: "NOK", implanted_market: false },
  { id: "PHP", name: "Philippine peso (₱)", symbol: "₱", implanted_market: false },
  { id: "PLN", name: "Polish zloty (PLN)", symbol: "PLN", implanted_market: true },
  { id: "RON", name: "Romanian new leu (RON)", symbol: "RON", implanted_market: true },
  { id: "RUB", name: "Russian ruble (₽)", symbol: "₽", implanted_market: false },
  { id: "SGD", name: "Singapore dollar (SGD)", symbol: "SGD", implanted_market: true },
  { id: "ZAR", name: "Sout African rand (R)", symbol: "R", implanted_market: false },
  { id: "KRW", name: "South Korea won (₩)", symbol: "₩", implanted_market: true },
  { id: "SEK", name: "Swedish krona (SEK)", symbol: "SEK", implanted_market: true },
  { id: "CHF", name: "Swiss franc (CHF)", symbol: "CHF", implanted_market: true },
  { id: "THB", name: "Thai baht (฿)", symbol: "฿", implanted_market: false },
  { id: "TRY", name: "Turkish lira (₺)", symbol: "₺", implanted_market: false },
  { id: "USD", name: "U.S. dollar (US$)", symbol: "US$", implanted_market: true },
  { id: "JPY", name: "Yen (¥)", symbol: "¥", implanted_market: false },
  { id: "AFN", name: "Afghani (AFN)", symbol: "AFN", implanted_market: false },
  { id: "ALL", name: "Albania Lek (LEK)", symbol: "LEK", implanted_market: false },
  { id: "DZD", name: "Algerian Dinar (DA)", symbol: "DA", implanted_market: false },
  { id: "AOA", name: "Kwanza (Kz)", symbol: "KZ", implanted_market: false },
  { id: "XCD", name: "Eastern Caribbean dollar (EC$)", symbol: "EC$" },
  { id: "ARS", name: "Peso (AR$)", symbol: "AR$", implanted_market: false },
  { id: "AMD", name: "Dram (AMD)", symbol: "AMD", implanted_market: false },
  { id: "AWG", name: "Aruban (ƒ)", symbol: "ƒ", implanted_market: false },
  { id: "AZN", name: "Manat (m)", symbol: "m", implanted_market: false },
  { id: "BSD", name: "Bahamian Dollar ($)", symbol: "BS$", implanted_market: true },
  { id: "BHD", name: "Bahraini dinar (BD)", symbol: "BD", implanted_market: false },
  { id: "BDT", name: "Taka (Tk)", symbol: "Tk", implanted_market: false },
  { id: "BBD", name: "Barbadian dollar ($)", symbol: "BB$", implanted_market: false },
  { id: "BYN", name: "Ruble (Br)", symbol: "Br", implanted_market: false },
  { id: "BZD", name: "Belize dollar (BZ$)", symbol: "BZ$", implanted_market: false },
  { id: "XOF", name: "West African CFA franc (CFA)", symbol: "CFA", implanted_market: false },
  { id: "BMD", name: "Bermudian dollar (BM$)", symbol: "BM$", implanted_market: false },
  { id: "BTN", name: "Ngultrum (Nu)", symbol: "Nu", implanted_market: false },
  { id: "BOB", name: "Bolivian Boliviano (Bs)", symbol: "Bs", implanted_market: false },
  { id: "BAM", name: "Bosnian Mark (KM)", symbol: "KM", implanted_market: false },
  { id: "BWP", name: "Botswana Pula (P)", symbol: "P", implanted_market: false },
  { id: "BRL", name: "Brazilian real (R$)", symbol: "R$", implanted_market: true },
  { id: "BND", name: "Brunei Dollar (B$)", symbol: "B$", implanted_market: false },
  { id: "BIF", name: "Burundi Franc (Fbu)", symbol: "Fbu", implanted_market: false },
  { id: "KHR", name: "Cambodian riel (KHR)", symbol: "KHR", implanted_market: false },
  { id: "XAF", name: "Central African CFA franc (FCFA)", symbol: "FCFA", implanted_market: false },
  { id: "ECV", name: "Unidad de valor constante (UVC)", symbol: "UVC", implanted_market: false },
  { id: "KYD", name: "Caymanian Dollar (CI$)", symbol: "CI$", implanted_market: true },
  { id: "CLF", name: "Chilean Unit of Account (UF)", symbol: "UF", implanted_market: false },
  { id: "COU", name: "Unidad de Valor Real (COU)", symbol: "COU", implanted_market: false },
  { id: "KMF", name: "Comorian franc (CF)", symbol: "CF", implanted_market: false },
  { id: "CDF", name: "Congolese Franc (CDF)", symbol: "CDF", implanted_market: false },
  { id: "CRC", name: "Costa Rican colón (₡)", symbol: "₡", implanted_market: false },
  { id: "CUP", name: "Cuban peso (CUP)", symbol: "CUP", implanted_market: false },
  { id: "DJF", name: "Djibouti Franc (Fdj)", symbol: "Fdj", implanted_market: false },
  { id: "DOP", name: "Dominican Peso (RD$)", symbol: "RD$", implanted_market: false },
  { id: "EGP", name: "Egyptian pound (E£)", symbol: "E£", implanted_market: false },
  { id: "ERN", name: "Eritrean nakfa (ERN)", symbol: "ERN", implanted_market: false },
  { id: "ETB", name: "Ethiopian Birr (Br)", symbol: "Br", implanted_market: false },
  { id: "FKP", name: "Falkland Islands Pound (FK£)", symbol: "FK£", implanted_market: false },
  { id: "FJD", name: "Fijian Dollar (FJ$)", symbol: "FJ$", implanted_market: false },
  { id: "XPF", name: "CFP franc (CFP)", symbol: "CFP", implanted_market: false },
  { id: "GMD", name: "Gambian Dalasi (D)", symbol: "D", implanted_market: false },
  { id: "GEL", name: "Georgian lari (ლარი)", symbol: "ლარი", implanted_market: false },
  { id: "GHS", name: "Ghanaian cedi (GH₵)", symbol: "GH₵", implanted_market: false },
  { id: "GIP", name: "Gibraltar Pound (£)", symbol: "£", implanted_market: false },
  { id: "GTQ", name: "Guatemalan quetzal (Q)", symbol: "Q", implanted_market: false },
  { id: "GNF", name: "Guinean franc (FG)", symbol: "FG", implanted_market: false },
  { id: "GYD", name: "Guyanese Dollar (G$)", symbol: "G$", implanted_market: false },
  { id: "HTG", name: "Haitian Gourde (G)", symbol: "G", implanted_market: false },
  { id: "HNL", name: "Honduran Lempira (L)", symbol: "L", implanted_market: false },
  { id: "ISK", name: "Icelandic króna (kr)", symbol: "kr", implanted_market: false },
  { id: "IRR", name: "Iranian rial (IRR)", symbol: "IRR", implanted_market: false },
  { id: "IQD", name: "Iraqi Dinar (IQD)", symbol: "IQD", implanted_market: false },
  { id: "JMD", name: "Jamaican Dollar (J$)", symbol: "J$", implanted_market: false },
  { id: "JOD", name: "Jordanian Dinar (JD)", symbol: "JD", implanted_market: false },
  { id: "KZT", name: "Kazakhstani tenge (₸)", symbol: "₸", implanted_market: false },
  { id: "KES", name: "Kenyan shilling (KSh)", symbol: "KSh", implanted_market: false },
  { id: "KPW", name: "North Korean Won (₩)", symbol: "₩", implanted_market: false },
  { id: "KWD", name: "Kuwaiti dinar (KWD)", symbol: "KWD", implanted_market: false },
  { id: "KGS", name: "Kyrgyzstani som (KGS)", symbol: "KGS", implanted_market: false },
  { id: "LAK", name: "Lao Kip (LAK)", symbol: "LAK", implanted_market: false },
  { id: "LBP", name: "Lebanese Pound (LL)", symbol: "LL", implanted_market: false },
  { id: "LSL", name: "Lesotho loti (L)", symbol: "L", implanted_market: false },
  { id: "LRD", name: "Liberian dollar (L$)", symbol: "L$", implanted_market: false },
  { id: "LYD", name: "Libyan Dinar (LYD)", symbol: "LYD", implanted_market: false },
  { id: "MOP", name: "Macanese pataca (MOP$)", symbol: "MOP$", implanted_market: false },
  { id: "MKD", name: "Macedonian denar (денар)", symbol: "денар", implanted_market: false },
  { id: "MGA", name: "Malagasy Ariary (Ar)", symbol: "Ar", implanted_market: false },
  { id: "MWK", name: "Malawian Kwacha (MK)", symbol: "MK", implanted_market: false },
  { id: "MVR", name: "Maldivian rufiyaa (Rf)", symbol: "Rf", implanted_market: false },
  { id: "MRO", name: "Mauritanian ouguiya (UM)", symbol: "UM", implanted_market: false },
  { id: "MUR", name: "Mauritian rupee (Rs)", symbol: "Rs", implanted_market: false },
  { id: "MDL", name: "Moldovan Leu (L)", symbol: "L", implanted_market: false },
  { id: "MNT", name: "Mongolian Tugrug (₮)", symbol: "₮", implanted_market: false },
  { id: "MAD", name: "Moroccan dirham (DH)", symbol: "DH", implanted_market: false },
  { id: "MZN", name: "Mozambican metical (MT)", symbol: "MT", implanted_market: false },
  { id: "MMK", name: "Myanmar Kyat (K)", symbol: "K", implanted_market: false },
  { id: "NAD", name: "Namibian Dollar (N$)", symbol: "N$", implanted_market: false },
  { id: "NPR", name: "Nepalese rupee (Rs)", symbol: "Rs", implanted_market: false },
  {
    id: "ANG",
    name: "Netherlands Antillean guilder (NAƒ)",
    symbol: "NAƒ",
    implanted_market: false
  },
  { id: "NIO", name: "Córdoba oro nicaraguayen (C$)", symbol: "C$", implanted_market: false },
  { id: "NGN", name: "Nigerian naira (₦)", symbol: "₦", implanted_market: false },
  { id: "OMR", name: "Omani rial (OMR)", symbol: "OMR", implanted_market: false },
  { id: "PKR", name: "Pakistani Rupee (Rp)", symbol: "Rp", implanted_market: false },
  { id: "PGK", name: "Papua New Guinea Kina (K)", symbol: "K", implanted_market: false },
  { id: "PYG", name: "Paraguay Guarani (₲)", symbol: "₲", implanted_market: false },
  { id: "PEN", name: "Peruvian Sol (S/)", symbol: "S/", implanted_market: false },
  { id: "QAR", name: "Qatari Riyal (QR)", symbol: "QR", implanted_market: false },
  { id: "RWF", name: "Rwandan franc (FRw)", symbol: "FRw", implanted_market: false },
  { id: "SHP", name: "Saint Helena Pound (SHP)", symbol: "SHP", implanted_market: false },
  { id: "WST", name: "Samoan Tala (WS$)", symbol: "WS$", implanted_market: false },
  { id: "STD", name: "São Tomé and Príncipe dobra (Db)", symbol: "Db", implanted_market: false },
  { id: "SAR", name: "Saudi Riyal (SR)", symbol: "SR", implanted_market: false },
  { id: "RSD", name: "Serbian Dinar (дин)", symbol: "дин", implanted_market: false },
  { id: "SCR", name: "Seychelles Rupee (SRe)", symbol: "SRe", implanted_market: false },
  { id: "SLL", name: "Sierra Leonean Leone (Le)", symbol: "Le", implanted_market: false },
  { id: "SBD", name: "Solomon Islands dollar (SI$)", symbol: "SI$", implanted_market: false },
  { id: "SOS", name: "Somali Shilling (Sh)", symbol: "Sh", implanted_market: false },
  { id: "LKR", name: "Sri Lankan Rupee (LKR)", symbol: "LKR", implanted_market: false },
  { id: "SDG", name: "New Sudanese Pound (SD)", symbol: "SD", implanted_market: false },
  { id: "SRD", name: "Surinamese dollar (Sr$)", symbol: "Sr$", implanted_market: false },
  { id: "SZL", name: "Swazi lilangeni (SZL)", symbol: "SZL", implanted_market: false },
  { id: "SYP", name: "Syrian Pound (£S)", symbol: "£S", implanted_market: false },
  { id: "TWD", name: "New Taiwan Dollar (NT$)", symbol: "NT$", implanted_market: false },
  { id: "TJS", name: "Tajikistani somoni (SM)", symbol: "SM", implanted_market: false },
  { id: "TZS", name: "Tanzanian shilling (TSh)", symbol: "TSh", implanted_market: false },
  { id: "TOP", name: "Tongan Pa'anga (T$)", symbol: "T$", implanted_market: false },
  { id: "TTD", name: "Trinidad and Tobago Dollar (TT$)", symbol: "TT$", implanted_market: false },
  { id: "TND", name: "Tunisian dinar (DT)", symbol: "DT", implanted_market: false },
  { id: "TMT", name: "Turkmenistan manat (T)", symbol: "T", implanted_market: false },
  { id: "UGX", name: "Ugandan Shilling (UGX)", symbol: "UGX", implanted_market: false },
  { id: "UAH", name: "Ukrainian hryvnia (грн)", symbol: "грн", implanted_market: false },
  { id: "AED", name: "United Arab Emirates dirham (AED)", symbol: "AED", implanted_market: false },
  { id: "UYU", name: "Uruguayan peso (U$)", symbol: "U$", implanted_market: false },
  { id: "UZS", name: "Uzbekistani Som (лв)", symbol: "лв", implanted_market: false },
  { id: "VUV", name: "Vanuatu Vatu (VT)", symbol: "VT", implanted_market: false },
  { id: "VEF", name: "Venezuelan bolívar (Bs.S)", symbol: "Bs", implanted_market: false },
  { id: "VND", name: "Vietnamese đồng (₫)", symbol: "₫", implanted_market: false },
  { id: "YER", name: "Yemeni Rial (YER)", symbol: "YER", implanted_market: false },
  { id: "ZMW", name: "Zambian kwacha (K)", symbol: "K", implanted_market: false },
  { id: "ZWL", name: "Zimbabwean dollar (Z$)", symbol: "Z$", implanted_market: false }
]

export const listWineTypes = [
  {
    id: 1,
    name: "Red"
  },
  {
    id: 2,
    name: "White"
  },
  {
    id: 3,
    name: "Rose"
  },
  {
    id: 4,
    name: "Sparkling"
  },
  {
    id: 5,
    name: "Fortified"
  },
  {
    id: 6,
    name: "Spirit"
  }
]

export const wineStockStatus = {
  DEFAULT: 1,
  AVAILABLE: 2,
  UNAVAILABLE: 3
}
export const wineRarities = {
  DEFAULT: {
    id: 1,
    name: "Default",
    stockText: " in stock",
    stockClass: "--available",
    wineInfoText: null
  },
  ON_DEMAND: {
    id: 2,
    name: "On demand",
    stockText: " on demand",
    stockClass: "--demand",
    wineInfoText: null
  },
  FINE_AND_RARE: {
    id: 3,
    name: "Fine & rare",
    stockText: " on demand only",
    stockClass: "--demand",
    wineInfoText: "Fine & rare"
  }
}

export const WineRangeAccessibilityEnum = {
  CORE_ITEM: 1,
  PREMIUM: 2,
  ULTRA_PREMIUM: 3,
  FINE_AND_RARE: 4
}
export const listWineRangeAccessibility = [
  {
    id: 1,
    name: "Core Item",
    textForUsers: "curious",
    textForProductFilters: "For every wine lover",
    displayGrantAccess: "For every wine lover : Core products",
    description: "Exploring the world of fine wines, discovering new flavors and experiences.",
    textWaitingAccessCategory: null,
    minAmount: 0,
    maxAmount: 14999
  },
  {
    id: 2,
    name: "Premium",
    textForUsers: "connoisseur",
    textForProductFilters: "Reserved for connoisseurs",
    displayGrantAccess: "Reserved for connoisseur : Premium products",
    description:
      "A refined palate with a growing appreciation and understanding of what makes an exceptional wine.",
    textWaitingAccessCategory: null,
    minAmount: 15000,
    maxAmount: 24999
  },
  {
    id: 3,
    name: "Ultra-Premium",
    textForUsers: "infamous connoisseur",
    textForProductFilters: "Reserved for infamous connoisseurs",
    displayGrantAccess: "Reserved for infamous connoisseur : Ultra premium products",
    description: "Recognized for a deep knowledge of wines and a passion for legendary vintages.",
    textWaitingAccessCategory:
      "We are excited for you to taste the exceptional wines of an infamous connoisseur membership, while giving access to our exclusive and confidential experiences worldwide.",
    minAmount: 25000,
    maxAmount: 49999
  },
  {
    id: 4,
    name: "Fine & Rare",
    textForUsers: "thirsty connoisseur",
    textForProductFilters: "Reserved for thirsty connoisseurs",
    displayGrantAccess: "Reserved for thirsty connoisseur : Fine & rare products",
    description: "An esteemed expert with an unparalleled thirst for the finest wines.",
    textWaitingAccessCategory:
      "We eagerly await the day you can savor the exclusive wines of a Thirsty Connoisseur membership, while giving access to our exclusive and confidential experiences worldwide in addition to opening the doors of the most sought-after wineries.",
    minAmount: 50000,
    maxAmount: null
  }
]

/* TODO : Deplace in WineComponent */
export const listBodyStructures = [
  { structure: "1", text: "Full bodied" },
  { structure: "2", text: "Medium bodied" },
  { structure: "3", text: "Light bodied" }
]

export const stockTypes = {
  stock: "Stock",
  consignment: "Direct Producer"
}
export const stockStatus = [
  { id: "OPEN", value: 1, label: "Open" },
  { id: "CLOSED", value: 2, label: "Closed" }
]
export const STOCK_PART = {
  STATUS: {
    STANDARD: {
      id: 0,
      name: "Standard"
    },
    PRESELL: {
      id: 1,
      name: "Pre-arrival"
    }
  }
}

export const alcoholLevelCategories = [
  { id: 1, text: "< 5% ALC.", textForUsers: "< 12% ALC.", minValue: 0, maxValue: 5 },
  { id: 2, text: "5 - 7% ALC.", textForUsers: "< 12% ALC.", minValue: 5, maxValue: 7 },
  { id: 3, text: "7 - 10% ALC.", textForUsers: "< 12% ALC.", minValue: 7, maxValue: 10 },
  { id: 4, text: "10 - 12% ALC.", textForUsers: "< 12% ALC.", minValue: 10, maxValue: 12 },
  { id: 5, text: "12 - 14% ALC.", textForUsers: "12 - 14% ALC.", minValue: 12, maxValue: 14 },
  { id: 6, text: "14 - 16% ALC.", textForUsers: "14 - 16% ALC.", minValue: 14, maxValue: 16 },
  { id: 7, text: "16 - 20% ALC.", textForUsers: "> 16% ALC.", minValue: 16, maxValue: 20 },
  { id: 8, text: "20 - 25% ALC.", textForUsers: "> 16% ALC.", minValue: 20, maxValue: 25 },
  { id: 9, text: "25 - 30% ALC.", textForUsers: "> 16% ALC.", minValue: 25, maxValue: 30 },
  { id: 10, text: "30 - 35% ALC.", textForUsers: "> 16% ALC.", minValue: 30, maxValue: 35 },
  { id: 11, text: "35 - 40% ALC.", textForUsers: "> 16% ALC.", minValue: 35, maxValue: 40 },
  { id: 12, text: "40 - 45% ALC.", textForUsers: "> 16% ALC.", minValue: 40, maxValue: 45 },
  { id: 13, text: "45 - 50% ALC.", textForUsers: "> 16% ALC.", minValue: 45, maxValue: 50 },
  { id: 14, text: "50 - 55% ALC.", textForUsers: "> 16% ALC.", minValue: 50, maxValue: 55 },
  { id: 15, text: "> 55% ALC.", textForUsers: "> 16% ALC.", minValue: 55, maxValue: 100.01 }
]

export const orderTypes = {
  STANDARD: 0,
  STANDALONE: 1,
  CONTAINER: 2
}
export const orderStatus = [
  {
    id: "CREATED",
    status: 1,
    value: "Created",
    shortValue: "Created",
    valueBuyer: "Created",
    editStatusLabel: "Created",
    cssClass: "white-color",
    icon: require("../assets/images/icons/add.svg")
  },
  {
    id: "AWAITING_VALIDATION",
    status: 3,
    value: "Awaiting validation",
    shortValue: "Aw. validation",
    valueBuyer: "Awaiting validation",
    editStatusLabel: "Awaiting validation",
    cssClass: "white-color",
    icon: require("../assets/images/icons/awaiting.svg")
  },
  {
    id: "AWAITING_CUSTOMER_VALIDATION",
    status: 2,
    value: "Awaiting customer validation",
    shortValue: "Aw. Cust. Validation",
    valueBuyer: "Your validation",
    editStatusLabel: "Awaiting customer validation",
    cssClass: "white-color",
    icon: require("../assets/images/icons/awaiting.svg")
  },
  {
    id: "ADJUSTING",
    status: 12,
    value: "Adjusting",
    shortValue: "Adjusting",
    valueBuyer: "Adjusting",
    editStatusLabel: "On adjustment",
    cssClass: "orange-color",
    icon: require("../assets/images/icons/awaiting.svg")
  },
  {
    id: "VALIDATED",
    status: 4,
    value: "Validated",
    shortValue: "Validated",
    valueBuyer: "Validated",
    editStatusLabel: "Approve order",
    cssClass: "green-color",
    icon: require("../assets/images/icons/validate.svg")
  },
  {
    id: "IN_PREPARATION",
    status: 5,
    value: "In preparation",
    shortValue: "In preparation",
    valueBuyer: "In preparation",
    editStatusLabel: "Prepare order",
    cssClass: "green-color",
    icon: require("../assets/images/icons/delivery-warehouse.svg")
  },
  {
    id: "DELIVERY",
    status: 6,
    value: "In delivery",
    shortValue: "In delivery",
    valueBuyer: "In delivery",
    editStatusLabel: "Ship order / Brokerage",
    cssClass: "green-color",
    icon: require("../assets/images/icons/delivery-truck.svg")
  },
  {
    id: "CUSTOMS_CLEARANCE",
    status: 7,
    value: "Customs clearance",
    shortValue: "Customs clearance",
    valueBuyer: "Customs clearance",
    editStatusLabel: "Customs clearance",
    cssClass: "green-color",
    icon: require("../assets/images/icons/delivery-officer.svg")
  },
  {
    id: "DELIVERED",
    status: 8,
    value: "Delivered",
    shortValue: "Delivered",
    valueBuyer: "Delivered",
    editStatusLabel: "Order delivered",
    cssClass: "green-color",
    icon: require("../assets/images/icons/delivery.svg")
  },
  {
    id: "CANCELLED",
    status: 9,
    value: "Cancelled",
    shortValue: "Cancelled",
    valueBuyer: "Cancelled",
    editStatusLabel: "Cancel order",
    cssClass: "red-color",
    icon: require("../assets/images/icons/cancel.svg")
  },
  {
    id: "ON_HOLD",
    status: 11,
    value: "On hold",
    shortValue: "On hold",
    valueBuyer: "On hold",
    editStatusLabel: "On hold",
    cssClass: "orange-color",
    icon: require("../assets/images/icons/on_hold.svg")
  },
  {
    id: "INBOUND",
    status: 13,
    value: "Inbound",
    shortValue: "Inbound",
    valueBuyer: "Put Inbound",
    editStatusLabel: "Stored inbound",
    cssClass: "green-color",
    icon: require("../assets/images/icons/delivery-warehouse.svg")
  },
  {
    id: "SUBCONTAINER_PUT_INBOUND",
    status: 14,
    value: "Put inbound",
    shortValue: "Put inbound",
    valueBuyer: "Put Inbound",
    editStatusLabel: "Put inbound",
    cssClass: "green-color",
    icon: require("../assets/images/icons/delivery-warehouse.svg")
  },
  {
    id: "SUBCONTAINER_CONTAINER_IN_TRANSIT",
    status: 15,
    value: "In transit",
    shortValue: "In transit",
    valueBuyer: "In transit",
    editStatusLabel: "In transit",
    cssClass: "green-color",
    icon: require("../assets/images/icons/delivery-truck.svg")
  }
]
export function getOrderStatusLabel(status) {
  return orderStatus.find(x => x.status === status).value
}
export function getOrderStatusShortLabel(status) {
  return orderStatus.find(x => x.status === status).shortValue
}
export function getOrderStatusBuyerLabel(status) {
  return orderStatus.find(x => x.status === status).valueBuyer
}
export function getOrderStatusIcon(status) {
  return orderStatus.find(x => x.status === status).icon
}
export function getOrderStatusInt(id) {
  return orderStatus.find(x => x.id === id).status
}
export function getOrderStatusInts(ids) {
  return orderStatus.filter(x => ids.includes(x.id)).map(x => x.status)
}

export const itemStatus = [
  { id: "CREATED", status: 1, value: "Created" },
  { id: "UPDATED_QTY", status: 2, value: "Updated qty" },
  { id: "REMOVED", status: 3, value: "Item removed" },
  { id: "DELETED", status: 4, value: "Deleted" }
]

//Status for which order can evolve
export const orderStatusOngoing = [
  orderStatus.filter(os => {
    return os.id === "AWAITING_VALIDATION"
  })[0].status,
  orderStatus.filter(os => {
    return os.id === "VALIDATED"
  })[0].status,
  orderStatus.filter(os => {
    return os.id === "IN_PREPARATION"
  })[0].status,
  orderStatus.filter(os => {
    return os.id === "DELIVERY"
  })[0].status,
  orderStatus.filter(os => {
    return os.id === "CUSTOMS_CLEARANCE"
  })[0].status
]
//Status for which order can be adjusted
export const orderStatusAdjusting = [
  orderStatus.filter(os => {
    return os.id === "AWAITING_VALIDATION"
  })[0].status,
  orderStatus.filter(os => {
    return os.id === "AWAITING_CUSTOMER_VALIDATION"
  })[0].status,
  orderStatus.filter(os => {
    return os.id === "ADJUSTING"
  })[0].status
]

//Status for which order can return back to last status
export const orderStatusStopped = [
  orderStatus.filter(os => {
    return os.id === "ON_HOLD"
  })[0].status
]

export const expeditionMethods = {
  SEA_FREIGHT: {
    id: 1,
    text: "Sea Freight",
    faIcon: "fa-anchor",
    defaultEtaMinHours: 480,
    defaultEtaMaxHours: 720
  },
  GROUND_FREIGHT: {
    id: 2,
    text: "Ground Freight",
    faIcon: "fa-truck",
    defaultEtaMinHours: 168,
    defaultEtaMaxHours: 240
  },
  AIR_FREIGHT: {
    id: 3,
    text: "Air Freight",
    faIcon: "fa-plane",
    defaultEtaMinHours: 168,
    defaultEtaMaxHours: 240
  },
  GROUND_EXPRESS: {
    id: 4,
    text: "Ground Express",
    faIcon: "fa-truck",
    defaultEtaMinHours: 72,
    defaultEtaMaxHours: null
  },
  AIR_EXPRESS: {
    id: 5,
    text: "Air Express",
    faIcon: "fa-plane",
    defaultEtaMinHours: 96,
    defaultEtaMaxHours: null
  },
  CELLAR_STORAGE: {
    id: 6,
    text: "Stored at the cellar",
    faIcon: "fa-warehouse",
    defaultEtaMinHours: 2184,
    defaultEtaMaxHours: 2184
  },
  CONTROLLED_TEMPERATURE: {
    id: 7,
    text: "Controlled temperature",
    faIcon: "fa-temperature-low",
    defaultEtaMinHours: 120,
    defaultEtaMaxHours: 192
  }
}
export const expeditionMethodList = [
  expeditionMethods.AIR_EXPRESS,
  expeditionMethods.AIR_FREIGHT,
  expeditionMethods.GROUND_EXPRESS,
  expeditionMethods.GROUND_FREIGHT,
  expeditionMethods.SEA_FREIGHT,
  expeditionMethods.CONTROLLED_TEMPERATURE,
  expeditionMethods.CELLAR_STORAGE
]

export const inboundDeliveryStatus = [
  {
    id: "DRAFT",
    status: 1,
    value: "Draft",
    shortValue: "Draft",
    valueBuyer: "Draft",
    editStatusLabel: "Draft",
    cssClass: "white-color",
    icon: require("../assets/images/icons/add.svg")
  },
  {
    id: "AWAITING_CUSTOMER_VALIDATION",
    status: 2,
    value: "Awaiting customer validation",
    shortValue: "Aw. Cust. Validation",
    valueBuyer: "Your validation",
    editStatusLabel: "Awaiting customer validation",
    cssClass: "white-color",
    icon: require("../assets/images/icons/awaiting.svg")
  },
  {
    id: "AWAITING_VALIDATION",
    status: 3,
    value: "Awaiting validation",
    shortValue: "Aw. validation",
    valueBuyer: "Awaiting validation",
    editStatusLabel: "Awaiting validation",
    cssClass: "white-color",
    icon: require("../assets/images/icons/awaiting.svg")
  },
  {
    id: "ADJUSTING",
    status: 12,
    value: "Adjusting",
    shortValue: "Adjusting",
    valueBuyer: "Adjusting",
    editStatusLabel: "On adjustment",
    cssClass: "orange-color",
    icon: require("../assets/images/icons/awaiting.svg")
  },
  {
    id: "VALIDATED",
    status: 4,
    value: "Validated",
    shortValue: "Validated",
    valueBuyer: "Validated",
    editStatusLabel: "Approve order",
    cssClass: "green-color",
    icon: require("../assets/images/icons/validate.svg")
  },
  {
    id: "IN_PREPARATION",
    status: 5,
    value: "In preparation",
    shortValue: "In preparation",
    valueBuyer: "In preparation",
    editStatusLabel: "Prepare order",
    cssClass: "green-color",
    icon: require("../assets/images/icons/delivery-warehouse.svg")
  },
  {
    id: "DELIVERY",
    status: 6,
    value: "In delivery",
    shortValue: "In delivery",
    valueBuyer: "In delivery",
    editStatusLabel: "Ship order / Brokerage",
    cssClass: "green-color",
    icon: require("../assets/images/icons/delivery-truck.svg")
  },
  {
    id: "DELIVERED",
    status: 8,
    value: "Delivered",
    shortValue: "Delivered",
    valueBuyer: "Delivered",
    editStatusLabel: "Order delivered",
    cssClass: "green-color",
    icon: require("../assets/images/icons/delivery.svg")
  },
  {
    id: "CANCELLED",
    status: 9,
    value: "Cancelled",
    shortValue: "Cancelled",
    valueBuyer: "Cancelled",
    editStatusLabel: "Cancel order",
    cssClass: "red-color",
    icon: require("../assets/images/icons/cancel.svg")
  },
  {
    id: "ON_HOLD",
    status: 11,
    value: "On hold",
    shortValue: "On hold",
    valueBuyer: "On hold",
    editStatusLabel: "On hold",
    cssClass: "orange-color",
    icon: require("../assets/images/icons/on_hold.svg")
  }
]

export const conciergerieTypesRequest = [
  {
    text: "Wine recommendation from our specialist",
    contact_type: 6
  },
  {
    text: "Custom-made private events or stays",
    contact_type: 7
  },
  {
    text: "Specific product delivery",
    contact_type: 8
  },
  {
    text: "Specific product and/or vintage",
    contact_type: 9
  },
  {
    text: "Specific product price request",
    contact_type: 16
  },
  {
    text: "Other",
    contact_type: 17
  }
]

export const paging = {
  SMALL: 12,
  DEFAULT: 24,
  BIG: 48
}
export const defaultPagingChoices = [
  {
    text: "12 entries",
    value: 12
  },
  {
    text: "24 entries",
    value: 24
  },
  {
    text: "48 entries",
    value: 48
  }
]

/* TODO : Deplace in MvtStockListComponent */
export const mvtTypes = [
  {
    text: "Acquired",
    value: "acquisition"
  },
  {
    text: "Allocated",
    value: "allocated"
  },
  {
    text: "Future from PO",
    value: "future_in_from_po"
  },
  {
    text: "Fill order",
    value: "fill_order"
  },
  {
    text: "Added to cart",
    value: "added_basket"
  },
  {
    text: "Removed from cart",
    value: "removed_basket"
  },
  {
    text: "Ordered",
    value: "ordered"
  },
  {
    text: "Order cancelled",
    value: "cancelled"
  },
  {
    text: "Changed in order",
    value: "changed_order"
  },
  {
    text: "Stock transfer",
    value: "stock_transfer"
  },
  {
    text: "C.Note return",
    value: "cn_return_inventory"
  },
  {
    text: "Updated",
    value: "update"
  },
  {
    text: "Adjusted manually",
    value: "manual_adjustement"
  },
  {
    text: "Deleted",
    value: "deleted"
  }
]

export const casingWines = [
  {
    textCard: "1 btl. (OC1)",
    text: "Original Casing, 1 bottle",
    value: "OC1",
    quantity: 1
  },
  {
    textCard: "2 btl. (OC2)",
    text: "Original Casing, 2 bottles",
    value: "OC2",
    quantity: 2
  },
  {
    textCard: "3 btl. (OC3)",
    text: "Original Casing, 3 bottles",
    value: "OC3",
    quantity: 3
  },
  {
    textCard: "6 btl. (OC6)",
    text: "Original Casing, 6 bottles",
    value: "OC6",
    quantity: 6
  },
  {
    textCard: "12 btl. (OC12)",
    text: "Original Casing, 12 bottles",
    value: "OC12",
    quantity: 12
  },
  {
    textCard: "24 btl. (OC24)",
    text: "Original Casing, 24 bottles",
    value: "OC24",
    quantity: 24
  },
  {
    textCard: "1 btl. (OWC1)",
    text: "Original wood casing, 1 bottle",
    value: "OWC1",
    quantity: 1
  },
  {
    textCard: "2 btl. (OWC2)",
    text: "Original wood casing, 2 bottles",
    value: "OWC2",
    quantity: 2
  },
  {
    textCard: "3 btl. (OWC3)",
    text: "Original wood casing, 3 bottles",
    value: "OWC3",
    quantity: 3
  },
  {
    textCard: "6 btl. (OWC6)",
    text: "Original wood casing, 6 bottles",
    value: "OWC6",
    quantity: 6
  },
  {
    textCard: "12 btl. (OWC12)",
    text: "Original wood casing, 12 bottles",
    value: "OWC12",
    quantity: 12
  },
  {
    textCard: "24 btl. (OWC24)",
    text: "Original wood casing, 24 bottles",
    value: "OWC24",
    quantity: 24
  }
]

export const bottlings = [
  {
    text: "375ml",
    value: 375
  },
  {
    text: "500ml",
    value: 500
  },
  {
    text: "700ml",
    value: 700
  },
  {
    text: "750ml",
    value: 750
  },
  {
    text: "1500ml",
    value: 1500
  },
  {
    text: "3000ml",
    value: 3000
  },
  {
    text: "4500ml",
    value: 4500
  },
  {
    text: "5000ml",
    value: 5000
  },
  {
    text: "6000ml",
    value: 6000
  },
  {
    text: "9000ml",
    value: 9000
  }
]

export const paymentState = {
  SUCCEEDED: "Succeeded",
  PROCESSING: "Processing",
  ACKNOWLEDGED: "Acknowledged",
  DEFERRED: "Deferred",
  FAILED: "Failed"
}
export const paymentStates = [
  { id: "Succeeded", name: "Succeeded" },
  { id: "Processing", name: "Processing" },
  { id: "Failed", name: "Failed" },
  { id: "Deferred", name: "Deferred" },
  { id: "Acknowledged", name: "In review" }
]
export function getPublicPaymentStateForAdmins(orderPaymentState) {
  if (orderPaymentState === paymentState.SUCCEEDED) return "Paid"
  else if (orderPaymentState === paymentState.ACKNOWLEDGED) return "Needs support review"
  else return `Payment ${orderPaymentState}`
}

export const paymentTypes = [
  { id: 1, name: "Credit Card", isDebitable: true },
  { id: 2, name: "Sepa Direct Debit", isDebitable: true },
  { id: 3, name: "ACH", isDebitable: true },
  { id: 4, name: "Other bank transfer", isDebitable: false },
  { id: 5, name: "Check", isDebitable: false },
  { id: 6, name: "Other", isDebitable: false },
  { id: 7, name: "Stripe link", isDebitable: false },
  { id: 8, name: "PVVTMCH", isDebitable: false }
]
export const paymentTypesWithCN = paymentTypes.concat([
  { id: 9, name: "Credit note", isDebitable: false }
])

export const StringHsCode = [
  {
    code: "220410",
    desc: "220410 - Sparkling wine of fresh grapes",
    isSpirit: false
  },
  {
    code: "220421",
    desc: "220421 - Wine of fresh grapes, in containers <= 2 l",
    isSpirit: false
  },
  {
    code: "220422",
    desc: "220422 - Wine of fresh grapes, in containers > 2 l and <= 10 l",
    isSpirit: false
  },
  {
    code: "2204",
    desc: "2204 - Wine of fresh grapes, alcoholic strength > 0.5%",
    isSpirit: false
  },
  {
    code: "220820",
    desc:
      "220820 - Spirits obtained by distilling grape wine or grape marc (Cognac, Armagnac, Brandy, Grappa, ...)",
    isSpirit: true
  },
  {
    code: "220830",
    desc: "220830 - Whiskies",
    isSpirit: true
  },
  {
    code: "220840",
    desc: "220840 - Rum and other spirits obtained by distilling fermented sugar-cane products",
    isSpirit: true
  },
  {
    code: "220850",
    desc: "220850 - Gin and Geneva",
    isSpirit: true
  },
  {
    code: "220860",
    desc: "220860 - Vodka",
    isSpirit: true
  },
  {
    code: "220870",
    desc: "220870 - Liqueurs and cordials",
    isSpirit: true
  }
]

export const tenantType = {
  OWNER: "owner",
  TENANT: "tenant"
}

/* Deplace in order.js */
export const upsErrors = {
  "120302":
    "An error has occurred with one of our products, please contact support. We apologise for the inconvenience",
  "120801": "Unable to recognize the specified address",
  "120207": "Your postal code is missing or incorrect",
  "120213":
    "Your phone number must be at least 10 alphanumeric characters. Please, change it in the profile page"
}

/* TODO : Deplace in wineComponent */
export const wineErrors = {
  accountancycode_exists: "The SKU already exists.",
  wine_exists: "There is already a product with the same data : ",
  supplier_price_empty: "Supplier price is missing for this wine."
}

/* TODO : Deplace in order.js and rename for ADD_ITEM_ERRORS */
export const buyLimitErrors = {
  BUY_LIMIT_REACHED: {
    value: "BUY_LIMIT_REACHED",
    text: "Are you sure you want to allow bypass buy limits for this order ?"
  }
}

/* TODO : Deplace in ResetPassword */
export const resetPasswordErrors = {
  user_account_deactivated: {
    title: "Not allowed",
    linkTitle: "Home",
    description: "Your are not allowed to reset your password."
  },
  user_not_found: {
    title: "Account not found",
    linkTitle: "Home",
    description: "This email is not associated with any valid account."
  }
}

export const purchaseOrder = {
  receiptStatus: {
    AWAITING: 1,
    1: { text: "Awaiting" },
    RECEIVED: 2,
    2: { text: "Received" }
  },
  paymentStatus: {
    BILLED: 1,
    1: { text: "Billed" },
    PAID: 2,
    2: { text: "Paid" }
  },
  status: {
    DRAFT: 1,
    1: { text: "Draft" },
    OPEN: 2,
    2: { text: "Open" },
    CLOSED: 3,
    3: { text: "Closed" },
    CANCELLED: 4,
    4: { text: "Cancelled" }
  },
  paymentMethod: {
    CREDIT_CART: 1,
    1: { text: "Credit card" },
    BANK_TRANSFER: 2,
    2: { text: "Bank transfer" },
    BANK_DRAFT: 3,
    3: { text: "Bank draft" },
    DIRECT_DEBIT: 4,
    4: { text: "Direct debit" },
    CHEQUE: 5,
    5: { text: "Cheque" }
  }
}

export const creditNote = {
  status: {
    DRAFT: 0,
    0: { text: "Draft" },
    VALIDATED: 1,
    1: { text: "Validated" },
    CLOSED: 2,
    2: { text: "Closed" }
  }
}
export const creditNoteUse = {
  status: {
    IN_PROGRESS: 1,
    1: { text: "In progress" },
    APPLIED: 2,
    2: { text: "Applied" },
    MANUAL_REFUND: 3,
    3: { text: "Manual refund" },
    CANCELED: 4,
    4: { text: "Canceled" }
  }
}
export const creditNoteItem = {
  type: {
    CUSTOM: 1,
    PRODUCT: 2,
    SHIPPING: 3
  }
}

export const imgDbType = {
  MAIN: {
    id: 1,
    label: "Main image"
  },
  SECONDARY: {
    id: 2,
    label: "Secondariy image"
  }
}

export const orderAdjustmentsTypes = {
  USER_DECLINE: {
    id: 1,
    textAdmin: "Customer cancelled the order",
    textUser: "You cancelled the order"
  },
  USER_ASK_ADJUSTMENT: {
    id: 2,
    textAdmin: "Customer asked for adjustment",
    textUser: "You asked for adjustment"
  },
  USER_APPROVE: {
    id: 3,
    textAdmin: "Customer approved adjustment",
    textUser: "You approved adjustment"
  },
  ADMIN_DECLINE: {
    id: 4,
    textAdmin: "The order has been declined",
    textUser: "The order has been declinedr"
  },
  ADMIN_PROPOSE_ADJUSTMENT: {
    id: 5,
    textAdmin: "An adjustment has been proposed",
    textUser: "An adjustment has been proposed"
  }
}

export const listContinents = [
  { id: "EU", display_name: "Europe" },
  { id: "NA", display_name: "North America" },
  { id: "AS", display_name: "Asia" },
  { id: "SA", display_name: "South America" },
  { id: "AF", display_name: "Africa" },
  { id: "OC", display_name: "Oceania" },
  { id: "", display_name: "Not defined" }
]

export const stockReservationTypes = {
  DEFAULT: {
    id: 0,
    name: "Not reserved",
    shortListLabel: ""
  },
  GROUP_HORECA_WHOLESALER: {
    id: 1,
    name: "Reserved for professionals & wholesalers",
    shortListLabel: "PRO"
  },
  GROUP_USER: {
    id: 2,
    name: "Reserved for individuals",
    shortListLabel: "IND"
  },
  SPECIFIC_CUSTOMER: {
    id: 3,
    name: "Reserved for a customer",
    shortListLabel: "%SPECIFIC_CUSTOMER%"
  },
  SPECIFIC_CONSULTANT: {
    id: 4,
    name: "Reserved for a corporate",
    shortListLabel: "%SPECIFIC_CONSULTANT%"
  }
}

export const orderOneClickActionTypes = {
  CUSTOMER_APPROVE: {
    id: 1,
    label: "Approve"
  },
  CANCEL: {
    id: 2,
    label: "Cancel"
  }
}

export const inboundDeliveryOneClickActionTypes = {
  CUSTOMER_APPROVE: {
    id: 1,
    label: "Approve"
  },
  CANCEL: {
    id: 2,
    label: "Cancel"
  }
}

export const IMPORTER = {
  customerTypes: {
    HORECA: {
      id: 1,
      name: "Professionals"
    },
    USER: {
      id: 2,
      name: "Individuals"
    },
    WHOLESALER: {
      id: 3,
      name: "Wholesalers"
    }
  },
  getimporterCustomerTypeIdFromUserGroup(userGroup) {
    if (userGroup.toUpperCase() === "HORECA" || userGroup.toUpperCase() === "ADMIN") {
      return IMPORTER.customerTypes.HORECA.id
    } else if (userGroup.toUpperCase() === "WHOLESALER") {
      return IMPORTER.customerTypes.WHOLESALER.id
    } else {
      return IMPORTER.customerTypes.USER.id
    }
  },

  invoicingMomentTypes: {
    ORDER_DELIVERED: {
      id: 0,
      name: "Order delivered"
    }
  }
}

export const documentTypes = {
  WINE: {
    id: 1,
    label: "Wine"
  },
  WINERY: {
    id: 2,
    label: "Winery"
  },
  ORDER: {
    id: 3,
    label: "Order"
  },
  PURCHASE_ORDER: {
    id: 4,
    label: "Purchase order"
  },
  CREDIT_NOTE: {
    id: 5,
    label: "Credit note"
  },
  INBOUND_DELIVERY: {
    id: 6,
    label: "Order dispatch"
  }
}
export const DOCUMENT_TAGS = {
  ORDER_FINAL_INVOICE: {
    tagId: 12,
    name: "Your invoices"
  }
}

export const emptyCellContent = "-"

export const platformDocumentTypes = {
  ORDERS_AUTO: {
    id: 1,
    label: "Order file",
    description: "Order documents created by plaform"
  },
  ORDERS_ATTACHED: {
    id: 2,
    label: "Order attached file",
    description: "Order documents added on attached files"
  },
  PURCHASE_ORDERS_AUTO: {
    id: 3,
    label: "Purchaserder file",
    description: "Purchase order documents created by plaform"
  },
  PURCHASE_ORDERS_ATTACHED: {
    id: 4,
    label: "Purchase order attached file",
    description: "Purchase order documents added on attached files"
  },
  CREDIT_NOTES_AUTO: {
    id: 5,
    label: "Credit note file",
    description: "Credit notes documents created by plaform"
  },
  CREDIT_NOTES_ATTACHED: {
    id: 6,
    label: "Credit note attached file",
    description: "Credit notes documents added on attached files"
  },
  WINES_ATTACHED: {
    id: 7,
    label: "Product attached file",
    description: "Products documents added on attached files"
  },
  WINERIES_ATTACHED: {
    id: 8,
    label: "Producer attached file",
    description: "Producers documents added on attached files"
  },
  INBOUND_DELIVERIES_AUTO: {
    id: 9,
    label: "Order dispatch file",
    description: "Order dispatch documents created by plaform"
  },
  INBOUND_DELIVERIES_ATTACHED: {
    id: 10,
    label: "Order dispatch attached file",
    description: "Order dispatch documents added on attached files"
  },
  ORDERS_CONFIRMATION_AUTO: {
    id: 11,
    label: "Order confirmation file",
    description: "Order confirmation documents created by plaform"
  },
  ORDERS_CONFIRMATION_ATTACHED: {
    id: 12,
    label: "Order confirmation attached file",
    description: "Order confirmation documents added on attached files"
  }
}

export const pricePostingUsaProConstants = [
  { state: "New York", iso2: "NY", idState: 37 },
  { state: "New Jersey", iso2: "NJ", idState: 35 },
  { state: "Connecticut", iso2: "CT", idState: 8 }
]
export const pricePostingStatusList = {
  GENERATING: {
    id: 1,
    text: "Generating",
    cssClass: "info"
  },
  DRAFT: {
    id: 2,
    text: "Draft",
    cssClass: "warning"
  },
  POSTED: {
    id: 3,
    text: "Posted",
    cssClass: "success"
  },
  CANCELLED: {
    id: 4,
    text: "Cancelled",
    cssClass: "neutral-dark"
  },
  BATCH_CREATION_FAILED: {
    id: 5,
    text: "File error",
    cssClass: "danger"
  }
}

export const TASTING_PHOTOS = {
  REQUIRED: {
    STATUS: {
      TO_TAKE: {
        id: 0,
        name: "To take"
      },
      PARTIALLY_TAKEN: {
        id: 1,
        name: "Partially taken"
      },
      FULLY_TAKEN: {
        id: 2,
        name: "Fully taken"
      },
      CANCELLED: {
        id: 3,
        name: "Cancelled"
      }
    }
  },
  TAKEN: {
    STATUS: {
      TO_TRANSFER: {
        id: 0,
        name: "To transfer",
        nameForUser: "Awaiting validation"
      },
      TRANSFERRED: {
        id: 1,
        name: "Transferred",
        nameForUser: "Validated"
      },
      CANCELLED: {
        id: 2,
        name: "Cancelled",
        nameForUser: "Cancelled"
      }
    }
  }
}

export const STOCK_TRANSFER_DOMESTIC = {
  STATUS: {
    PENDING: {
      id: 0,
      name: "Pending"
    },
    DELIVERED: {
      id: 1,
      name: "Delivered"
    },
    CANCELLED: {
      id: 2,
      name: "Cancelled"
    }
  }
}

export const COMPARISON_OPERATORS = {
  EQUAL: {
    value: "=",
    text: "=",
    textForUrlQuery: "equal"
  },
  NOT_EQUAL: {
    value: "!=",
    text: "<>",
    textForUrlQuery: "notEqual"
  },
  LOWER: {
    value: "<",
    text: "<",
    textForUrlQuery: "lower"
  },
  LOWER_OR_EQUAL: {
    value: "<=",
    text: "<=",
    textForUrlQuery: "lowerOrEqual"
  },
  GREATER: {
    value: ">",
    text: ">",
    textForUrlQuery: "greater"
  },
  GREATER_OR_EQUAL: {
    value: ">=",
    text: ">=",
    textForUrlQuery: "greaterOrEqual"
  }
}

export const userSubscriptionStatus = {
  PENDING: { id: "PENDING", name: "Pending" },
  ACCEPTED: { id: "ACCEPTED", name: "Accepted" },
  DECLINED: { id: "DECLINED", name: "Declined" }
}

export const cloneDbEnvironment = {
  PRODUCTION: "PRODUCTION",
  DevProdDebug: "DevProdDebug",
  DevTom: "DevTom",
  TestTom: "TestTom",
  DevCM: "DevCM",
  TestCM: "TestCM"
}

export const MONTHS = {
  JANUARY: { id: 1, name: "January" },
  FEBRUARY: { id: 2, name: "February" },
  MARCH: { id: 3, name: "March" },
  APRIL: { id: 4, name: "April" },
  MAY: { id: 5, name: "May" },
  JUNE: { id: 6, name: "June" },
  JULY: { id: 7, name: "July" },
  AUGUST: { id: 8, name: "August" },
  SEPTEMBER: { id: 9, name: "September" },
  OCTOBER: { id: 10, name: "October" },
  NOVEMBER: { id: 11, name: "November" },
  DECEMBER: { id: 12, name: "December" }
}

export const allowedBrazilCreditCardTypes = [
  { id: "visa", name: "Visa" },
  { id: "mastercard", name: "Mastercard" }
]
